import React from 'react'
import styled from 'styled-components';

import colors from './theme';

const MainContainer = styled.div`
width: 100vw;
height: 20vh;
background-color: rgb(0,0,0,0.75);
display: flex;
flex-drection: row;
position: absolute;
bottom: 0px;`


const LocationContainer = styled.div`
width: 50%;
display: flex;
flex-direction: column;
font-family: rubik;
justify-content: center;
@media(max-width: 575px){
    width: 35%;
}
@media(max-width: 350px){
    width: 45%
}
`

const PriceAndAvailabilityContainer = styled.div`
width: 50%;
display: flex;
flex-direction: row;
font-family: rubik;
@media(max-width: 1200px){
    flex-direction: column;
    align-items: flex-end;
}
@media(max-width: 575px){
    width: 65%;
}
@media(max-width: 350px){
    width: 55%
}
`

const DetailsContainer = styled.div`
width: 33%;
display: flex;
flex-direction: column;
justify-content: center;
height: 100%;
@media(max-width: 1200px){
    flex-direction: row;
    align-items: center;
    height: 33%;
    width: 50%;
    justify-content: space-between;
}
@media(max-width: 768px){
    width: 75%;
}
@media(max-width: 375px){
    width: 100%;
}
`

const SectionLabel = styled.h1`
font-size: 24px;
text-transform: uppercase;
font-weight: 100;
color: ${colors.gray};
@media(max-width: 1200px){
    font-size: 16px;
}
@media(max-width: 450px){
    font-size: 14px;
}
@media(max-width: 400px){
    font-size: 13px;
}
@media(max-width: 350px){
    font-size: 11px;
}`


const PropertyName = styled.h1`
color: ${colors.pink};
font-size: 3em;
font-weight: 700;
padding: 0 0 0 1em;
@media (max-width: 1600px){
    font-size: 2em;
}
@media (max-width: 1000px){
    font-size: 2em;
    width: 75%;
}

`

const Details = styled.h3`
color:${colors.blue};
font-size: 1.5em;
font-weight: 500;
@media(max-width: 1200px) {
    font-size: 1em;
    padding-right: 10px`


const SpaceDetails = (props) => {
    return (
        <MainContainer>
            <LocationContainer>
                <SectionLabel>
                    <PropertyName>
                        18th and Linden
                    </PropertyName>
                </SectionLabel>
            </LocationContainer>
            <PriceAndAvailabilityContainer>
                <DetailsContainer>
                    <SectionLabel>
                        Rate
                    </SectionLabel>
                    <Details>
                        From $1398
                    </Details>
                </DetailsContainer>
                <DetailsContainer>
                    <SectionLabel>
                        Availability
                    </SectionLabel>
                    <Details>
                        Starting 6/1
                    </Details>
                </DetailsContainer>
                <DetailsContainer>
                    <SectionLabel>
                        Duration
                    </SectionLabel>
                    <Details>
                        6 months +
                    </Details>
                </DetailsContainer>
            </PriceAndAvailabilityContainer>
        </MainContainer>
    )
}

export default SpaceDetails;